export default __webpack_public_path__ + "static/media/iso.f2a0f3ae.webp";